// extracted by mini-css-extract-plugin
module.exports = {"jumb":"Especifico_jumb__CqhX7","static":"Especifico_static__2sN8d","icon":"Especifico_icon__FU6BE"};